import type { FaireProductEntity } from "../../entity_types/product";

export const p_hcez9wag3h: FaireProductEntity = {
  token: "p_hcez9wag3h",
  type: "product",
  name: "The Nordic Baking Book",
  brandToken: "b_daarv8jc3a",
  brandName: "Phaidon",
  imageUrl:
    "https://cdn.faire.com/fastly/dfb97ea9c10b8186f7b495be5f1917660b79f8c8947b20d01e84cbbe852ef634.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0212b72147bed2877239d57008a68c0605e765834fbb19ca314a5f818ef7de94.webp",
    "https://cdn.faire.com/fastly/e88cda1347c3146f78d6e31fad6aa6a484430640c197177dbae2f8e8cd10859c.webp",
    "https://cdn.faire.com/fastly/7d6e4d8f6af84e7bb8d38605331f595238b1cf5d0e83efb3b9ebb1904dd3dd9e.webp",
    "https://cdn.faire.com/fastly/78db7604907ed591e264841f9d768295fc9b6712fe7bcd1727ea9e14e19ec27a.webp",
    "https://cdn.faire.com/fastly/4ebb210f8b850deb3cbcc2dcc41d9544cd1198773af8a5b72293086c1e0614d9.webp",
    "https://cdn.faire.com/fastly/2e594f042b83f5309e91600277cc2969a86880b60252d2b5eb9e834b5678cb2f.webp",
    "https://cdn.faire.com/fastly/ec920fafdf9b4ec65b636c367a37b4f088559725752305d0e03d1ff3a964c6cb.webp",
  ],
  priceDollars: 28.57,
  description:
    "The acclaimed chef featured in the Emmy-Award winning US PBS series The Mind of a Chef and the Netflix docuseries Chef's Table explores the rich baking tradition of the Nordic region, with 450 tempting recipes for home bakers\n\nNordic culture is renowned for its love of baking and baked goods: hot coffee is paired with cinnamon buns spiced with cardamom, and cold winter nights are made cozier with the warmth of the oven. No one is better equipped to explore this subject than acclaimed chef Magnus Nilsson. In The Nordic Baking Book, Nilsson delves into all aspects of Nordic home baking - modern and traditional, sweet and savory - with recipes for everything from breads and pastries to cakes, cookies, and holiday treats.\n\nNo other book on Nordic baking is as comprehensive and informative. Nilsson travelled extensively throughout the Nordic region – Denmark, the Faroe Islands, Finland, Greenland, Iceland, Norway, and Sweden - collecting recipes and documenting the landscape. ",
  tags: [],
  msrpDollars: 54.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:55.458Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
